exports.ByName = {
  Cover: { Id: 1, Name: 'Cover', Localization: 'reports.section_cover' },
  ComplianceOverview: { Id: 2, Name: 'ComplianceOverview', Localization: 'reports.section_compliance_overview' },
  LocalDocumentationIndex: { Id: 3, Name: 'LocalDocumentationIndex', Localization: 'reports.section_local_documentation_index' },
  ExecutiveSummary: { Id: 4, Name: 'ExecutiveSummary', Localization: 'reports.section_executive_summary' },
  LegalEntityOverview: { Id: 5, Name: 'LegalEntityOverview', Localization: 'reports.section_legal_entity_overview' },
  ControlledTransactionOverview: { Id: 6, Name: 'ControlledTransactionOverview', Localization: 'reports.section_controlled_transaction_overview' },
  MethodEvaluation: { Id: 7, Name: 'MethodEvaluation', Localization: 'reports.section_method_evaluation' },
  ProfitBasedAnalysis: { Id: 8, Name: 'ProfitBasedAnalysis', Localization: 'reports.section_profit_based_analysis' },
  TransactionBasedAnalysis: { Id: 9, Name: 'TransactionBasedAnalysis', Localization: 'reports.section_transaction_based_analysis' }
};

exports.ById = {
  1: { Id: 1, Name: 'Cover', Localization: 'reports.section_cover' },
  2: { Id: 2, Name: 'ComplianceOverview', Localization: 'reports.section_compliance_overview' },
  3: { Id: 3, Name: 'LocalDocumentationIndex', Localization: 'reports.section_local_documentation_index' },
  4: { Id: 4, Name: 'ExecutiveSummary', Localization: 'reports.section_executive_summary' },
  5: { Id: 5, Name: 'LegalEntityOverview', Localization: 'reports.section_legal_entity_overview' },
  6: { Id: 6, Name: 'ControlledTransactionOverview', Localization: 'reports.section_compliance_overview' },
  7: { Id: 7, Name: 'MethodEvaluation', Localization: 'reports.section_method_evaluation' },
  8: { Id: 8, Name: 'ProfitBasedAnalysis', Localization: 'reports.section_profit_based_analysis' },
  9: { Id: 9, Name: 'TransactionBasedAnalysis', Localization: 'reports.section_transaction_based_analysis' }
};
